import createScrollOpt from "@/assets/js/vuescrollOption";

export default {
  _myOpt: {
    vuescrollOpt: createScrollOpt(),
    notEvalua: "NotEvalua",
    isEvalua: "IsEvalua"
  },
  components: {
    "yioks-paging": () => import("@/components/Pagination/Page"),
    "yioks-loading": () => import("@/components/Loading/Loading"),
    "yioks-empty": () => import("@/components/Tips/Empty"),
    "yioks-class-info": () => import("@/components/ClassInfoBox/ClassInfoBox"),
    "yioks-evaluat-search": () => import("@/components/EvaluaSearch/EvaluaSearch"),
  },
  created() {
    this.setData();
    this.ratingList();
  },
  data() {
    return {
      searchData: {
        date: "",
        status: "",
        keywords: "",
        class_level: "",
      },
      thePage: 1,
      paging: {
        start: 0,
        prePage: 1, // 一页多少条数据
        total: 1, // 总页数
        size: 3, // 页码显示限制
        last: true, // 尾页
        first: true, // 首页
        next: true, // 下一页
        previous: true, // 上一页
        jump: true
      },
      isEmpty: false,
      isLoading: true,
    }
  },
  methods: {
    setData() {
      const {page, date, status, keywords,class_level} = this.$route.query;
      page && (this.thePage = page);
      date && this.$set(this.searchData, "date", date);
      status && this.$set(this.searchData, "status", status);
      keywords && this.$set(this.searchData, "keywords", keywords);
      class_level && this.$set(this.searchData, "class_level", class_level);
    },
    dateChange(date) {
      this.searchData.date = date;
      this.changeQuery(true);
    },
    levelChange(class_level) {
      this.searchData.class_level = class_level;
      this.changeQuery(true);
    },
    statusChange(status) {
      this.searchData.status = status;
      this.changeQuery(true);
    },
    keywordsChange(keywords) {
      this.searchData.keywords = keywords
    },
    searchList() {
      this.changeQuery(true);
    },
    hideIconReq(keywords) {
      this.searchData.keywords = keywords;
      this.changeQuery(true);
    },
    gotoPage(start) {
      this.thePage = parseInt(start / this.paging.prePage) + 1;
      this.changeQuery(false);
    },
    changeQuery(flag) {
      flag && (this.thePage = 1);
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          page: this.thePage,
          date: this.searchData.date,
          status: this.searchData.status,
          keywords: this.searchData.keywords,
          class_level: this.searchData.class_level,
        }
      });
      this.ratingList();
    },
  }
}